/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftiePlainDate } from './ShiftiePlainDate';
import {
    ShiftiePlainDateFromJSON,
    ShiftiePlainDateFromJSONTyped,
    ShiftiePlainDateToJSON,
    ShiftiePlainDateToJSONTyped,
} from './ShiftiePlainDate';

/**
 * 
 * @export
 * @interface LeaveAllowanceChunkMocked
 */
export interface LeaveAllowanceChunkMocked {
    /**
     * 
     * @type {ShiftiePlainDate}
     * @memberof LeaveAllowanceChunkMocked
     */
    date: ShiftiePlainDate;
    /**
     * 
     * @type {number}
     * @memberof LeaveAllowanceChunkMocked
     */
    allowanceUsedInDays: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveAllowanceChunkMocked
     */
    allowanceUsedInHours: number;
    /**
     * 
     * @type {number}
     * @memberof LeaveAllowanceChunkMocked
     */
    paidHours: number;
}

/**
 * Check if a given object implements the LeaveAllowanceChunkMocked interface.
 */
export function instanceOfLeaveAllowanceChunkMocked(value: object): value is LeaveAllowanceChunkMocked {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('allowanceUsedInDays' in value) || value['allowanceUsedInDays'] === undefined) return false;
    if (!('allowanceUsedInHours' in value) || value['allowanceUsedInHours'] === undefined) return false;
    if (!('paidHours' in value) || value['paidHours'] === undefined) return false;
    return true;
}

export function LeaveAllowanceChunkMockedFromJSON(json: any): LeaveAllowanceChunkMocked {
    return LeaveAllowanceChunkMockedFromJSONTyped(json, false);
}

export function LeaveAllowanceChunkMockedFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaveAllowanceChunkMocked {
    if (json == null) {
        return json;
    }
    return {
        
        'date': ShiftiePlainDateFromJSON(json['date']),
        'allowanceUsedInDays': json['allowanceUsedInDays'],
        'allowanceUsedInHours': json['allowanceUsedInHours'],
        'paidHours': json['paidHours'],
    };
}

  export function LeaveAllowanceChunkMockedToJSON(json: any): LeaveAllowanceChunkMocked {
      return LeaveAllowanceChunkMockedToJSONTyped(json, false);
  }

  export function LeaveAllowanceChunkMockedToJSONTyped(value?: LeaveAllowanceChunkMocked | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': ShiftiePlainDateToJSON(value['date']),
        'allowanceUsedInDays': value['allowanceUsedInDays'],
        'allowanceUsedInHours': value['allowanceUsedInHours'],
        'paidHours': value['paidHours'],
    };
}

